const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL
const FB_APP_ID = process.env.REACT_APP_FB_APP_ID
const OLD_PRODUCT_IMAGE_BASE_URL = process.env.REACT_APP_OLD_PRODUCT_IMAGE_BASE_URL

export { API_BASE_URL, IMAGE_BASE_URL, FB_APP_ID, OLD_PRODUCT_IMAGE_BASE_URL }